import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import { DatePicker } from '@material-ui/pickers'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />)

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  root: {
    '& > *': {
      color: '#fff',
    },
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  embe: {
    justifyContent: 'center',
  },
}))

const ModalPrevViewFiles = (props) => {
  const [selectedDate, handleDateChange] = useState(new Date())
  const classes = useStyles()

  const { open, handleClose, handlePrevView, section, url = [] } = props

  return (
    <div>
      <Dialog
        open={open}
        fullScreen
        TransitionComponent={Transition}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AppBar style={{ background: '#333333' }} className={classes.appBar}>
          <Toolbar>
            <Grid container justifyContent="center">
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="subtitle1" className={classes.title}>
                Seleccione año y mes
              </Typography>
              <DatePicker
                variant="inline"
                openTo="year"
                autoOk
                maxDate={new Date()}
                className={classes.root}
                views={['year', 'month']}
                label="Año y mes"
                value={selectedDate}
                onChange={handleDateChange}
              />
            </Grid>
            <Button
              autoFocus
              color="inherit"
              onClick={() =>
                handlePrevView({
                  seccion: section.title,
                  yyyy: selectedDate.getFullYear(),
                  mm: selectedDate.getMonth(),
                })
              }
            >
              Buscar
            </Button>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <DialogContent id="alert-dialog-description">
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12}>
                {Array.isArray(url).length > 0 ? (
                  url.map((item, index) => (
                      <div className={classes.embed}>
                        <embed
                          src={url[index].url}
                          width="100%"
                          height="900"
                          type="application/pdf"
                        />
                      </div>
                    ))
                ) : (
                  <section className={classes.embed}>
                    <div>Selecciona la fecha del reporte para visualizar</div>
                  </section>
                )}
              </Grid>
            </Grid>
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ModalPrevViewFiles
